import { useLayoutEffect } from "react";
import { useIntl } from "react-intl";

/**
 * Sets the document title (aka the tab name in the browser)
 *
 * Pass in a title and it will be formatted accordingly
 * If the title is empty then we'll just use the default title so dont worry about it
 */
export function useDocumentTitle(title?: string | null) {
  const { formatMessage } = useIntl();

  useLayoutEffect(() => {
    window.document.title = formatMessage(
      { id: "app.title" },
      { section: title || "_" } // react-intl does not support select on empty
    );
  }, [formatMessage, title]);
}
